// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2Tg4G","actionsCol":"EnrolledClinics_actionsCol__MvBwB"};